<div>
  <mat-horizontal-stepper [linear]="true" #stepper>.

    <!--primer step datos de colegio - cedula-->
    <!--*************************************-->
    <!--*************************************-->
    <!--*************************************-->
    <mat-step [stepControl]="ColegioFormGroup">

      <form [formGroup]="ColegioFormGroup">

        <ng-template matStepLabel>Unidad educativa</ng-template>
        <div style="text-align: center;">
          <h1 class="main-div">Ficha de Inscripción para el Transporte Estudiantil</h1>
        </div>

        <div *ngIf="colegioSeleccionado" style="text-align: center;">
          <h1 class="main-div">Institución: {{colegioSeleccionado.getNombre()}}</h1>
        </div>
        <div class="main-div" style="padding-bottom: 80px;">
          <div class="card text-justify" style="width: 9rem;">
            <img src="../../../assets/LOGO.png" class="card-img-top">
            
          </div>
        </div>
        

        <div class="row">



          <div class="col-sm-6" style="width:800px; margin:0 auto;">
            <h6>version 3.5</h6>
            <p style="font-size: 11px;"><b>Nota:</b> Los campos marcados con * son obligatorios.</p>
            <mat-form-field appearance="outline" class="example-full-width" style="width: 100%;">
              <mat-label>Cédula/Pasaporte estudiante</mat-label>
              <input type="text" matInput formControlName="identification" required autocomplete="off" maxlength="20"
                [ngClass]="{'is-invalid': invalidField('identification')||identification.invalid && identification.errors?.pattern ||identification.invalid && identification.errors?.minlength||identification.invalid && identification.errors?.maxlength|| identification.errors?.vacuna}">


              <mat-error *ngIf="identification.invalid && identification.errors?.required"
                class="messagererrors textColorText">
                Campo <strong>requerido.</strong>
              </mat-error>

              <mat-error *ngIf="identification.invalid && identification.errors?.minlength"
                class="messagererrors textColorText">
                Ingrese <strong> mínimo 10 dígitos.</strong>
              </mat-error>

              <mat-error *ngIf="identification.invalid && identification.errors?.maxlength"
                class="messagererrors textColorText">
                Ingrese <strong> máximo 20 dígitos.</strong>
              </mat-error>

              <mat-error *ngIf="identification.invalid && identification.errors?.pattern"
                class="messagererrors textColorText">
                Campo <strong> númerico.</strong>
              </mat-error>



            </mat-form-field>
          </div>
        </div>
      </form>
      <div class="container" style="text-align: right;width: 100%;">
        <div class="row">
          <div class="col-lg-8 col-sm-0"></div>
          <div class="col">
            <button class="btn btn-primary" mat-button (click)="goForward(stepper)">Continuar</button>
          </div>
        </div>
      </div>

    </mat-step>



    <!--segundo step datos de estudiante-->
    <!--*************************************-->
    <!--*************************************-->
    <!--*************************************-->
    <mat-step [stepControl]="DatosEstudianteFormGroup">
      <form [formGroup]="DatosEstudianteFormGroup">
        <ng-template matStepLabel>Estudiante</ng-template>

        <div class="container" style="padding-top:30px ;">
          <div style="text-align: center;">
            <h1>Datos Estudiante</h1>
          </div>
          <p style="font-size: 11px;"><b>Nota:</b> Los campos marcados con * son obligatorios.</p>
          <div class="row">
            <div class="col-sm-6">

              <h1>Datos personales</h1>
              <div class="form-group">

                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Apellidos Completos</mat-label>
                  <input matInput formControlName="apellidosCompletos" required autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldSteapDos('apellidosCompletos')||apellidosCompletos.invalid && apellidosCompletos.errors?.pattern }">

                  <mat-error *ngIf="apellidosCompletos.invalid && apellidosCompletos.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>

                  <mat-error *ngIf="apellidosCompletos.invalid && apellidosCompletos.errors?.pattern"
                    class="messagererrors textColorText">
                    Campo <strong> alfabético.</strong>
                  </mat-error>

                </mat-form-field>
              </div>

              <div class="form-group">
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Nombres Completos</mat-label>
                  <input matInput formControlName="nombresCompletos" required autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldSteapDos('nombresCompletos')||nombresCompletos.invalid && nombresCompletos.errors?.pattern }">

                  <mat-error *ngIf="nombresCompletos.invalid && nombresCompletos.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>

                  <mat-error *ngIf="nombresCompletos.invalid && nombresCompletos.errors?.pattern"
                    class="messagererrors textColorText">
                    Campo <strong> alfabético.</strong>
                  </mat-error>
                </mat-form-field>
              </div>


              <div class="form-group">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Edad</mat-label>
                  <input type="text" matInput formControlName="edad" required maxlength="2" autocomplete="off"
                    (keypress)="validateNo($event)"
                    [ngClass]="{'is-invalid': invalidFieldSteapDos('edad')||edad.invalid && edad.errors?.pattern }">

                  <mat-error *ngIf="edad.invalid && edad.errors?.required" class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>

                  <mat-error *ngIf="edad.invalid && edad.errors?.pattern" class="messagererrors textColorText">
                    Campo <strong> númerico.</strong>
                  </mat-error>
                </mat-form-field>
              </div>

            </div>




            <div class="col-sm-6">
              <h1>Datos Acádemicos</h1>
              <div class="form-group">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Grado - Curso al que es promovido</mat-label>
                  <mat-select formControlName="gradoPromovido"
                    [ngClass]="{'is-invalid': invalidFieldSteapDos('gradoPromovido')}">
                    <div *ngIf="unidadEducativa!='SK'">
                      <mat-option *ngFor="let item of dataNiveles" value="{{item.codigo}}">
                        {{item.nivel}}</mat-option>
                    </div>

                    <div *ngIf="unidadEducativa=='SK'">
                      <mat-option *ngFor="let item of dataNivelesSEK" value="{{item.codigo}}">
                        {{item.nivel}}</mat-option>
                    </div>
                  </mat-select>



                  <mat-error *ngIf="gradoPromovido.invalid && gradoPromovido.errors?.required"
                    class="messagererrors textColorText">
                    Seleccione <strong>unidad educativa.</strong>
                  </mat-error>
                </mat-form-field>
              </div>


              <div class="form-group">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Paralelo</mat-label>
                  <mat-select formControlName="paralelo" [ngClass]="{'is-invalid': invalidFieldSteapDos('paralelo')}">
                    <mat-option value="NO SÉ">NO SÉ</mat-option>
                    <mat-option value="A">A</mat-option>
                    <mat-option value="B">B</mat-option>
                    <mat-option value="C">C</mat-option>
                    <mat-option value="D">D</mat-option>
                    <mat-option value="E">E</mat-option>
                    <mat-option value="F">F</mat-option>

                  </mat-select>

                  <mat-error *ngIf="paralelo.invalid && paralelo.errors?.required" class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>
                </mat-form-field>

              </div>
            </div>
          </div>




          <hr style="background-color: black;">

          <div style="text-align: center;">
            <h1>Datos Domiciliarios</h1>
          </div>


          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Sector domicilio</mat-label>
                  <mat-select formControlName="sector" [ngClass]="{'is-invalid': invalidFieldSteapDos('sector')}"
                    required>
                    <mat-option value="Norte">Norte</mat-option>
                    <mat-option value="Sur">Sur</mat-option>
                    <mat-option value="Centro">Centro</mat-option>
                    <mat-option value="Valle de los Chillos">Valle de los Chillos</mat-option>
                    <mat-option value="Valle de Tumbaco o Cumbaya">Valle de Tumbaco o Cumbayá
                    </mat-option>

                    <mat-option value="Nayon" *ngIf="unidadEducativa=='I'">Nayon</mat-option>
                    <mat-option value="Pomasqui" *ngIf="unidadEducativa=='I'">Pomasqui</mat-option>
                    <mat-option value="Mitad del Mundo" *ngIf="unidadEducativa=='I'">Mitad del Mundo</mat-option>
                  </mat-select>

                  <mat-error *ngIf="sector.invalid && sector.errors?.required" class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>

                </mat-form-field>
              </div>


              <div class="form-group">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Casa número</mat-label>
                  <input matInput formControlName="casaNo" required autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldSteapDos('casaNo') }">



                  <mat-error *ngIf="casaNo.invalid && casaNo.errors?.pattern" class="messagererrors textColorText">
                    Campo <strong>númerico.</strong>
                  </mat-error>
                </mat-form-field>
              </div>


              <div class="form-group">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Calle Principal</mat-label>
                  <input matInput formControlName="callePrincipal" required autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldSteapDos('callePrincipal') }">

                  <mat-error *ngIf="callePrincipal.invalid && callePrincipal.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>


                </mat-form-field>
              </div>


              <div class="form-group">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Calle Secundaria</mat-label>
                  <input matInput formControlName="calleSecundaria" required autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldSteapDos('calleSecundaria') }">

                  <mat-error *ngIf="calleSecundaria.invalid && calleSecundaria.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>


                </mat-form-field>
              </div>

            </div>


            <div class="col-sm-6">
              <div class="form-group">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Teléfono - celular </mat-label>
                  <input type="tel" matInput maxlength="10" formControlName="telefonoResidencia" required
                    (keypress)="validateNo($event)" autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldSteapDos('telefonoResidencia')||telefonoResidencia.invalid && telefonoResidencia.errors?.minlength||telefonoResidencia.invalid && telefonoResidencia.errors?.maxlength||telefonoResidencia.invalid && telefonoResidencia.errors?.pattern }">
                  <mat-error *ngIf="telefonoResidencia.invalid && telefonoResidencia.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>

                  <mat-error *ngIf="telefonoResidencia.invalid && telefonoResidencia.errors?.pattern"
                    class="messagererrors textColorText">
                    Campo <strong>númerico.</strong>
                  </mat-error>

                  <mat-error *ngIf="telefonoResidencia.invalid && telefonoResidencia.errors?.maxlength"
                    class="messagererrors textColorText">
                    Ingrese <strong>máximo 10 números.</strong>
                  </mat-error>


                  <mat-error *ngIf="telefonoResidencia.invalid && telefonoResidencia.errors?.minlength"
                    class="messagererrors textColorText">
                    Ingrese <strong>mínimo 7 números.</strong>
                  </mat-error>

                </mat-form-field>

              </div>


              <div class="form-group">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Referencia domiciliaria</mat-label>
                  <input matInput formControlName="referencia" required autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldSteapDos('referencia') }">

                  <mat-error *ngIf="referencia.invalid && referencia.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>



                </mat-form-field>

              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="container" style="text-align: right;width: 100%;">
        <div class="row">
          <div class="col-lg-8 col-sm-0"></div>
          <div class="col">
            <button class="btn btn-primary" mat-button (click)="goForward(stepper)">Continuar</button>&nbsp;&nbsp;
            <button class="btn btn-warning" mat-button (click)="goBack(stepper)">Regresar</button>
          </div>
        </div>
      </div>
    </mat-step>


    <!--tercer step datos representante-->
    <!--*************************************-->
    <!--*************************************-->
    <!--*************************************-->
    <mat-step [stepControl]="DatosRepresentanteFormGroup">
      <form [formGroup]="DatosRepresentanteFormGroup">
        <ng-template matStepLabel>Representante</ng-template>

        <div style="text-align: center;padding-top: 30px;">
          <h1>Datos representante principal</h1>
        </div>

        <div class="container">
          <p style="font-size: 11px;"><b>Nota:</b> Los campos marcados con * son obligatorios.</p>
          <div class="row">
            <div class="form-group col-sm-6">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Responsable de Contratación</mat-label>
                <mat-select formControlName="ResponsableContratacion" required
                  [ngClass]="{'is-invalid': invalidFieldStepTres('ResponsableContratacion') }">
                  <mat-option value="Mamá">Mamá</mat-option>
                  <mat-option value="Papá">Papá</mat-option>
                  <mat-option value="Otro">Otro</mat-option>
                </mat-select>
                <mat-error *ngIf="ResponsableContratacion.invalid && ResponsableContratacion.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group col-sm-6">
              <mat-form-field appearance="outline" class="example-full-width" style="width: 100%;">
                <mat-label>Cédula o pasaporte representante</mat-label>
                <input type="text" matInput formControlName="CedulaRepresentante" required autocomplete="off"
                  (keypress)="validateNo($event)" maxlength="20"
                  [ngClass]="{'is-invalid': invalidFieldStepTres('CedulaRepresentante')||CedulaRepresentante.invalid && CedulaRepresentante.errors?.pattern ||CedulaRepresentante.invalid && CedulaRepresentante.errors?.minlength||CedulaRepresentante.invalid && CedulaRepresentante.errors?.maxlength|| CedulaRepresentante.errors?.vacuna}">

                <mat-error *ngIf="CedulaRepresentante.invalid && CedulaRepresentante.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

                <mat-error *ngIf="CedulaRepresentante.invalid && CedulaRepresentante.errors?.minlength"
                  class="messagererrors textColorText">
                  Ingrese <strong> mínimo 10 dígitos.</strong>
                </mat-error>

                <mat-error *ngIf="CedulaRepresentante.invalid && CedulaRepresentante.errors?.maxlength"
                  class="messagererrors textColorText">
                  Ingrese <strong> máximo 20 dígitos.</strong>
                </mat-error>

                <mat-error *ngIf="CedulaRepresentante.invalid && CedulaRepresentante.errors?.pattern"
                  class="messagererrors textColorText">
                  Campo <strong> númerico.</strong>
                </mat-error>



              </mat-form-field>
            </div>

            <div class="form-group col-sm-6">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Nombres completos representante</mat-label>
                <input matInput formControlName="NombreRepresentante" required autocomplete="off"
                  [ngClass]="{'is-invalid': invalidFieldStepTres('NombreRepresentante')||NombreRepresentante.invalid && NombreRepresentante.errors?.pattern }">

                <mat-error *ngIf="NombreRepresentante.invalid && NombreRepresentante.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

                <mat-error *ngIf="NombreRepresentante.invalid && NombreRepresentante.errors?.pattern"
                  class="messagererrors textColorText">
                  Campo <strong> alfabético.</strong>
                </mat-error>
              </mat-form-field>
            </div>


            <div class="form-group col-sm-6">
              <mat-form-field style="width:100%" appearance="outline">
                <mat-label>Teléfono - celular representante</mat-label>
                <input type="tel" matInput maxlength="10" formControlName="TelefonoCelularRepresentante"
                  (keypress)="validateNo($event)" autocomplete="off" required
                  [ngClass]="{'is-invalid': invalidFieldStepTres('TelefonoCelularRepresentante')||TelefonoCelularRepresentante.invalid && TelefonoCelularRepresentante.errors?.minlength||TelefonoCelularRepresentante.invalid && TelefonoCelularRepresentante.errors?.maxlength||TelefonoCelularRepresentante.invalid && TelefonoCelularRepresentante.errors?.pattern }">
                <mat-error *ngIf="TelefonoCelularRepresentante.invalid && TelefonoCelularRepresentante.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

                <mat-error *ngIf="TelefonoCelularRepresentante.invalid && TelefonoCelularRepresentante.errors?.pattern"
                  class="messagererrors textColorText">
                  Campo <strong>númerico.</strong>
                </mat-error>

                <mat-error
                  *ngIf="TelefonoCelularRepresentante.invalid && TelefonoCelularRepresentante.errors?.maxlength"
                  class="messagererrors textColorText">
                  Ingrese <strong>máximo 10 números</strong>
                </mat-error>


                <mat-error
                  *ngIf="TelefonoCelularRepresentante.invalid && TelefonoCelularRepresentante.errors?.minlength"
                  class="messagererrors textColorText">
                  Ingrese <strong>mínimo 7 números</strong>
                </mat-error>
              </mat-form-field>
            </div>

            <div class="form-group col-sm-6">
              <mat-form-field style="width:100%" appearance="outline">
                <mat-label>Email representante</mat-label>
                <input type="email" matInput formControlName="EmailRepresentanteA" autocomplete="off"
                  [ngClass]="{'is-invalid': invalidFieldStepTres('EmailRepresentanteA')||EmailRepresentanteA.invalid && EmailRepresentanteA.errors?.pattern }"
                  required>

                <mat-error *ngIf="EmailRepresentanteA.invalid && EmailRepresentanteA.errors?.email"
                  class="messagererrors textColorText">
                  Email <strong>incorrecto.</strong>
                </mat-error>

                <mat-error *ngIf="EmailRepresentanteA.invalid && EmailRepresentanteA.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

              </mat-form-field>
            </div>
          </div>


          <hr style="background-color: black;">
          <div style="text-align: center;padding-top: 30px;">
            <h1>Datos representante secundario</h1>
          </div>

          <div class="row ">
            <div class="form-group col-sm-6">

              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Nombres completos representante</mat-label>
                <input matInput formControlName="NombreOtroRepresentante" autocomplete="off"
                  [ngClass]="{'is-invalid': invalidFieldStepTres('NombreOtroRepresentante')||NombreOtroRepresentante.invalid && NombreOtroRepresentante.errors?.pattern }">

                <mat-error *ngIf="NombreOtroRepresentante.invalid && NombreOtroRepresentante.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

                <mat-error *ngIf="NombreOtroRepresentante.invalid && NombreOtroRepresentante.errors?.pattern"
                  class="messagererrors textColorText">
                  Campo <strong> alfabético.</strong>
                </mat-error>

              </mat-form-field>
            </div>


            <div class="form-group col-sm-6">
              <mat-form-field style="width:100%" appearance="outline">
                <mat-label>Teléfono - celular representante</mat-label>
                <input type="tel" matInput maxlength="10" autocomplete="off" (keypress)="validateNo($event)"
                  formControlName="TelefonoCelularOtroRepresentante"
                  [ngClass]="{'is-invalid': invalidFieldStepTres('TelefonoCelularOtroRepresentante')||TelefonoCelularOtroRepresentante.invalid && TelefonoCelularOtroRepresentante.errors?.minlength||TelefonoCelularOtroRepresentante.invalid && TelefonoCelularOtroRepresentante.errors?.maxlength||TelefonoCelularOtroRepresentante.invalid && TelefonoCelularOtroRepresentante.errors?.pattern }">
                <mat-error
                  *ngIf="TelefonoCelularOtroRepresentante.invalid && TelefonoCelularOtroRepresentante.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

                <mat-error
                  *ngIf="TelefonoCelularOtroRepresentante.invalid && TelefonoCelularOtroRepresentante.errors?.pattern"
                  class="messagererrors textColorText">
                  Campo <strong>númerico.</strong>
                </mat-error>

                <mat-error
                  *ngIf="TelefonoCelularOtroRepresentante.invalid && TelefonoCelularOtroRepresentante.errors?.maxlength"
                  class="messagererrors textColorText">
                  Ingrese <strong>máximo 10 números</strong>
                </mat-error>


                <mat-error
                  *ngIf="TelefonoCelularOtroRepresentante.invalid && TelefonoCelularOtroRepresentante.errors?.minlength"
                  class="messagererrors textColorText">
                  Ingrese <strong>mínimo 7 números</strong>
                </mat-error>
              </mat-form-field>
            </div>


            <div class="form-group col-sm-6">
              <mat-form-field style="width:100%" appearance="outline">
                <mat-label>Email otro representante</mat-label>
                <input type="email" matInput formControlName="EmailOtroRepresentante" autocomplete="off"
                  [ngClass]="{'is-invalid': invalidFieldStepTres('EmailOtroRepresentante')||EmailOtroRepresentante.invalid && EmailOtroRepresentante.errors?.pattern }">

                <mat-error *ngIf="EmailOtroRepresentante.invalid && EmailOtroRepresentante.errors?.email"
                  class="messagererrors textColorText">
                  Email <strong>incorrecto.</strong>
                </mat-error>
                <mat-error *ngIf="EmailOtroRepresentante.invalid && EmailOtroRepresentante.errors?.required"
                  class="messagererrors textColorText">
                  Email <strong>requerido.</strong>
                </mat-error>
              </mat-form-field>
            </div>
          </div>


          <hr style="background-color: black;">
          <div style="text-align: center;padding-top: 30px;">
            <h1>Datos referencia familiar</h1>
          </div>
          <div class="row  ">
            <div class="form-group col-sm-6">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Parentesco</mat-label>
                <input matInput formControlName="ParentescoReferenciaFamiliar" required autocomplete="off"
                  [ngClass]="{'is-invalid': invalidFieldStepTres('ParentescoReferenciaFamiliar')||ParentescoReferenciaFamiliar.invalid && ParentescoReferenciaFamiliar.errors?.pattern }">

                <mat-error *ngIf="ParentescoReferenciaFamiliar.invalid && ParentescoReferenciaFamiliar.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

                <mat-error *ngIf="ParentescoReferenciaFamiliar.invalid && ParentescoReferenciaFamiliar.errors?.pattern"
                  class="messagererrors textColorText">
                  Campo <strong> alfabético.</strong>
                </mat-error>

              </mat-form-field>
            </div>


            <div class="form-group col-sm-6">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Nombres familiar</mat-label>
                <input matInput formControlName="NombreReferenciaFamiliar" required autocomplete="off"
                  [ngClass]="{'is-invalid': invalidFieldStepTres('NombreReferenciaFamiliar')||NombreReferenciaFamiliar.invalid && NombreReferenciaFamiliar.errors?.pattern }">

                <mat-error *ngIf="NombreReferenciaFamiliar.invalid && NombreReferenciaFamiliar.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

                <mat-error *ngIf="NombreReferenciaFamiliar.invalid && NombreReferenciaFamiliar.errors?.pattern"
                  class="messagererrors textColorText">
                  Campo <strong> alfabético.</strong>
                </mat-error>

              </mat-form-field>
            </div>


            <div class="form-group col-sm-6">
              <mat-form-field style="width:100%" appearance="outline">
                <mat-label>Teléfono familiar</mat-label>
                <input type="tel" matInput maxlength="9" formControlName="TelefonoReferenciaFamiliar" autocomplete="off"
                  (keypress)="validateNo($event)"
                  [ngClass]="{'is-invalid': invalidFieldStepTres('TelefonoReferenciaFamiliar')||TelefonoReferenciaFamiliar.invalid && TelefonoReferenciaFamiliar.errors?.minlength||TelefonoReferenciaFamiliar.invalid && TelefonoReferenciaFamiliar.errors?.maxlength||TelefonoReferenciaFamiliar.invalid && TelefonoReferenciaFamiliar.errors?.pattern }">


                <mat-error *ngIf="TelefonoReferenciaFamiliar.invalid && TelefonoReferenciaFamiliar.errors?.pattern"
                  class="messagererrors textColorText">
                  Campo <strong>númerico.</strong>
                </mat-error>

                <mat-error *ngIf="TelefonoReferenciaFamiliar.invalid && TelefonoReferenciaFamiliar.errors?.maxlength"
                  class="messagererrors textColorText">
                  Ingrese <strong>máximo 9 números</strong>
                </mat-error>


                <mat-error *ngIf="TelefonoReferenciaFamiliar.invalid && TelefonoReferenciaFamiliar.errors?.minlength"
                  class="messagererrors textColorText">
                  Ingrese <strong>mínimo 7 números</strong>
                </mat-error>

              </mat-form-field>

            </div>


            <div class="form-group col-sm-6">
              <mat-form-field style="width:100%" appearance="outline">
                <mat-label>Celular familiar</mat-label>
                <input type="tel" matInput maxlength="10" formControlName="CelularReferenciaFamiliar" autocomplete="off"
                  (keypress)="validateNo($event)" required
                  [ngClass]="{'is-invalid': invalidFieldStepTres('CelularReferenciaFamiliar')||CelularReferenciaFamiliar.invalid && CelularReferenciaFamiliar.errors?.minlength||CelularReferenciaFamiliar.invalid && CelularReferenciaFamiliar.errors?.maxlength||CelularReferenciaFamiliar.invalid && CelularReferenciaFamiliar.errors?.pattern }">
                <mat-error *ngIf="CelularReferenciaFamiliar.invalid && CelularReferenciaFamiliar.errors?.required"
                  class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

                <mat-error *ngIf="CelularReferenciaFamiliar.invalid && CelularReferenciaFamiliar.errors?.pattern"
                  class="messagererrors textColorText">
                  Campo <strong>númerico.</strong>
                </mat-error>

                <mat-error *ngIf="CelularReferenciaFamiliar.invalid && CelularReferenciaFamiliar.errors?.maxlength"
                  class="messagererrors textColorText">
                  Ingrese <strong>celular válido. Ejemplo: 0999999111</strong>
                </mat-error>

                <mat-error *ngIf="CelularReferenciaFamiliar.invalid && CelularReferenciaFamiliar.errors?.minlength"
                  class="messagererrors textColorText">
                  Ingrese <strong>celular válido. Ejemplo: 0999999111</strong>
                </mat-error>
              </mat-form-field>
            </div>



          </div>

        </div>

      </form>

      <div class="container" style="text-align: right;width: 100%;">

        <div class="row">
          <div class="col-lg-8 col-sm-0"></div>
          <div class="col"><button class="btn btn-primary" mat-button (click)="goForward(stepper)">Continuar</button>&nbsp;&nbsp;
            <button class="btn btn-warning" mat-button (click)="goBack(stepper)">Regresar</button>
            
          </div>
        </div>
      </div>

    </mat-step>



    <!--cuarto step factura-->
    <!--*************************************-->
    <!--*************************************-->
    <!--*************************************-->
    <mat-step [stepControl]="DatosFacturacionFormGroup">
      <form [formGroup]="DatosFacturacionFormGroup">
        <ng-template matStepLabel>Factura</ng-template>

        <div style="text-align: center;padding-top: 30px;">
          <h1>Factura</h1>
        </div>

        <div class="container">
          <div>
            <p><b>Detalle:</b> Ingrese los datos de la entidad que se utilizará para generar la factura.</p>
            <p style="font-size: 11px;"><b>Nota:</b> Los campos marcados con * son obligatorios.</p>
            <div class="row">


              <div class="form-group col-sm-6">
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Tipo documento</mat-label>
                  <mat-select formControlName="TipoDocumento" required
                    [ngClass]="{'is-invalid': invalidFieldStepCuatro('TipoDocumento') }">
                    <mat-option value="Cédula">Cédula</mat-option>
                    <mat-option value="RUC">RUC</mat-option>
                    <mat-option value="RUC">Pasaporte</mat-option>
                  </mat-select>
                  <mat-error *ngIf="TipoDocumento.invalid && TipoDocumento.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>
                </mat-form-field>
              </div>


              <div class="form-group col-sm-6">
                <mat-form-field appearance="outline" class="example-full-width" style="width: 100%;">
                  <mat-label>Cédula/RUC/Pasaporte</mat-label>
                  <input type="text" matInput formControlName="CedulaoRuc" required autocomplete="off" maxlength="20"
                    (keypress)="validateNo($event)"
                    [ngClass]="{'is-invalid': invalidFieldStepCuatro('CedulaoRuc') ||CedulaoRuc.invalid && CedulaoRuc.errors?.pattern}">

                  <mat-error *ngIf="CedulaoRuc.invalid && CedulaoRuc.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>

                  <mat-error *ngIf="CedulaoRuc.invalid && CedulaoRuc.errors?.pattern"
                    class="messagererrors textColorText">
                    Campo <strong> númerico.</strong>
                  </mat-error>

                  <mat-error *ngIf="cedulaboolean" class="messagererrors textColorText">
                    Ingrese <strong>los datos correctamente.</strong>
                  </mat-error>



                </mat-form-field>
              </div>




              <div class="form-group col-sm-6">

                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Nombres completos</mat-label>
                  <input matInput formControlName="NombreFactura" required autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldStepCuatro('NombreFactura')||NombreFactura.invalid && NombreFactura.errors?.pattern }">

                  <mat-error *ngIf="NombreFactura.invalid && NombreFactura.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>

                  <mat-error *ngIf="NombreFactura.invalid && NombreFactura.errors?.pattern"
                    class="messagererrors textColorText">
                    Campo <strong> alfabético.</strong>
                  </mat-error>

                </mat-form-field>
              </div>


              <div class="form-group col-sm-6">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Teléfono - celular</mat-label>
                  <input type="tel" matInput maxlength="10" formControlName="TelefonoFactura" required
                    (keypress)="validateNo($event)" autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldStepCuatro('TelefonoFactura')||TelefonoFactura.invalid && TelefonoFactura.errors?.minlength||TelefonoFactura.invalid && TelefonoFactura.errors?.maxlength||TelefonoFactura.invalid && TelefonoFactura.errors?.pattern }">
                  <mat-error *ngIf="TelefonoFactura.invalid && TelefonoFactura.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>

                  <mat-error *ngIf="TelefonoFactura.invalid && TelefonoFactura.errors?.pattern"
                    class="messagererrors textColorText">
                    Campo <strong>númerico.</strong>
                  </mat-error>

                  <mat-error *ngIf="TelefonoFactura.invalid && TelefonoFactura.errors?.maxlength"
                    class="messagererrors textColorText">
                    Ingrese <strong>máximo 10 números</strong>
                  </mat-error>


                  <mat-error *ngIf="TelefonoFactura.invalid && TelefonoFactura.errors?.minlength"
                    class="messagererrors textColorText">
                    Ingrese <strong>mínimo 7 números</strong>
                  </mat-error>

                </mat-form-field>

              </div>




              <div class="form-group col-sm-6">

                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Dirección</mat-label>
                  <input matInput formControlName="DireccionFactura" required autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldStepCuatro('DireccionFactura') }">

                  <mat-error *ngIf="DireccionFactura.invalid && DireccionFactura.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>



                </mat-form-field>
              </div>




              <div class="form-group col-sm-6">
                <mat-form-field style="width:100%" appearance="outline">
                  <mat-label>Email</mat-label>
                  <input type="email" matInput formControlName="EmailFactura" required autocomplete="off"
                    [ngClass]="{'is-invalid': invalidFieldStepCuatro('EmailFactura')||EmailFactura.invalid && EmailFactura.errors?.pattern }">



                  <mat-error *ngIf="EmailFactura.invalid && EmailFactura.errors?.email"
                    class="messagererrors textColorText">
                    Email <strong>incorrecto.</strong>
                  </mat-error>


                  <mat-error *ngIf="EmailFactura.invalid && EmailFactura.errors?.required"
                    class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>

                </mat-form-field>
              </div>

            </div>




          </div>
        </div>

      </form>

      <div class="container" style="text-align: right;width: 100%;">

        <div class="row">
          <div class="col-lg-8 col-sm-0"></div>
          <div class="col"><button class="btn btn-primary" mat-button (click)="goForward(stepper)">Continuar</button>&nbsp;&nbsp;
            <button class="btn btn-warning" mat-button (click)="goBack(stepper)">Regresar</button>
            
          </div>
        </div>
      </div>


    </mat-step>



    <!--cuarto step mapas->
          <!--*************************************-->
    <!--*************************************-->
    <!--*************************************-->
    <mat-step [stepControl]="DatosServicioTransporteFormGroup">
      <form [formGroup]="DatosServicioTransporteFormGroup">
        <ng-template matStepLabel>Servicio</ng-template>

        <h2 class="main-div"><b>Datos del Servicio de Transporte</b></h2>

        <p style="font-size: 11px;padding: 0px;" *ngIf="MuestraRutas=='NO'"><b>Nota:</b> Los campos marcados con * son
          obligatorios.</p>

        <div style="text-align: left; padding-top: 30px;" class="container">

          <mat-form-field appearance="outline" style="width: 100%;padding-bottom:0%">
            <mat-label>Tipo Servicio Transporte</mat-label>
            <mat-select formControlName="TipoServicioTransporte" (selectionChange)="cambioTipoServicio($event.value)"
              required [ngClass]="{'is-invalid': invalidField('TipoServicioTransporte')}" autocomplete="off">

              <ng-container *ngFor="let opcion of TiposServiciosArray">
                <mat-option [value]="opcion.codigo"> {{opcion.descripcion}} </mat-option>
              </ng-container>

            </mat-select>

            <mat-error *ngIf="TipoServicioTransporte.invalid && TipoServicioTransporte.errors?.required"
              class="messagererrors textColorText">
              Campo <strong>requerido.</strong>
            </mat-error>

          </mat-form-field>
        </div>

        <div *ngIf="MuestraRutas=='NO'" >

          <div class="row" *ngIf="mostrarCamposPaso4">
            <div class="col-md-6" style="text-align: center;">
              <div class="form-group">

                <h2>Embarcar estudiante</h2>
                <mat-form-field appearance="outline" style="width: 100%;">
                  <mat-label>Dirección Exacta - con calles, números y referencias</mat-label>
                  <input matInput placeholder="Dirección Exacta" formControlName="DireccionExacta" autocomplete="off"
                    required
                    [ngClass]="{'is-invalid': invalidField('DireccionExacta')||DireccionExacta.invalid && DireccionExacta.errors?.pattern}">

                  <mat-error *ngIf="DireccionExacta.invalid && DireccionExacta.errors?.required"
                    style="padding-top: 15px;" class="messagererrors textColorText">
                    Campo <strong>requerido.</strong>
                  </mat-error>



                </mat-form-field>



                <label style="text-align: justify;">Posicione el icono <mat-icon> place</mat-icon>
                  del mapa en el punto donde será embarcado el estudiante. </label>
                <div style="font-size: 80%;padding-top: 13px;cursor: pointer;color: blue;" (click)="helperMap()">
                  ¡Necesito
                  ayuda!</div>
                <ngx-place-picker (locationChanged)="this.locationDireccionChange($event)"
                  [enableCurrentLocation]="true" [enablePlacesSearch]="false"
                  [defaultLocation]="{'lat':latitudRecoijida,'lng':longitudRecojida,'zoom':13}">
                </ngx-place-picker>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <div *ngIf="tieneRetorno" style="text-align: center;">
                  <h2>Desembarcar estudiante</h2>
                  <mat-form-field style="width:100%" appearance="outline">
                    <mat-label>Dirección Exacta Retorno con calles, números y referencias
                    </mat-label>
                    <input matInput placeholder="Dirección Exacta Retorno" autocomplete="off" *ngIf="tieneRetorno"
                      formControlName="DireccionExactaRetorno" (keypress)="acciones()">

                  </mat-form-field>


                  <div style="text-align: left;" *ngIf="direccionRetornoP">
                    <label style="color: blue; font-size: 11px;"> Campo <strong>requerido.</strong></label>
                  </div>



                  <label style="text-align: justify;">Posicione el icono <mat-icon> place</mat-icon>
                    del mapa en el punto donde será desembarcado el estudiante. </label>
                  <div style="font-size: 80%;padding-top: 13px;cursor: pointer;color: blue;" (click)="helperMap()">
                    ¡Necesito ayuda!</div>
                  <ngx-place-picker (locationChanged)="this.locationDireccionRetornoChange($event)"
                    [enableCurrentLocation]="true" [enablePlacesSearch]="false"
                    [defaultLocation]="{'lat':this.latitudDeja,'lng':this.longitudDeja,'zoom':13}">
                  </ngx-place-picker>
                </div>
              </div>
            </div>
          </div>

        </div>



        <!--
          Inicia el grafico de rutas prestablecidas
        -->


        <div *ngIf="MuestraRutas=='SI' && seleccionTipo" style="padding: 50px;">




          <div class="row">
            <div class="col-sm-4">
              <div style="text-align: center;padding-top: 15px;"
                *ngIf="tiposervicio=='COMPLETO' ||tiposervicio=='OPCIONAL SOLO ENTRADA'||tiposervicio=='OPCIONAL SOLO SALIDA'">
                <strong> Por favor, seleccione una ruta dependiendo del color para establecer su trayectoria. </strong>
              </div>
            </div>
          </div>



          <div style="text-align: center;padding-top: 15px;" *ngIf="tiposervicio=='DOBLE RUTA' ">
            <strong> Por favor, seleccione máximo 2 rutas dependiendo del color para establecer su trayectoria.
            </strong>
          </div>




          <div class="row">


            <div class="col-sm-4"
              *ngIf="tiposervicio=='COMPLETO' ||tiposervicio=='OPCIONAL SOLO ENTRADA'||tiposervicio=='OPCIONAL SOLO SALIDA'">

              <mat-form-field appearance="outline" style="width: 100%;padding-bottom:0%">
                <mat-label>Seleccione Ruta</mat-label>
                <mat-select formControlName="ruta" (ngModelChange)="seleccionRutaEstablecida($event)" required
                  [ngClass]="{'is-invalid': invalidField('ruta')}" autocomplete="off">

                  <ng-container *ngFor="let opcion of points">
                    <mat-option [value]="opcion"> {{opcion.nombreRuta}} </mat-option>
                  </ng-container>

                </mat-select>

                <mat-error *ngIf="ruta.invalid && ruta.errors?.required" class="messagererrors textColorText">
                  Campo <strong>requerido.</strong>
                </mat-error>

              </mat-form-field>


            </div>




            <!----------
Mapa predefinido doble ruta-->


            <div class="col-sm-4" *ngIf="tiposervicio=='DOBLE RUTA' ">


            </div>





            <div class="col-sm" style="padding-top: 25px;">
              <div class="alert alert-primary" role="alert">
                Mapa
              </div>
              <agm-map [zoom]="12" [latitude]="lat" [longitude]="lng" [fitBounds]="true" [clickableIcons]="false"
                *ngIf="pointse.length>0">
                <div *ngFor="let point of pointse; let i = index">
                  <agm-polyline #line [editable]="false">

                    <agm-polyline-point *ngFor="let point of pointse[i].element" [latitude]="point.lat"
                      [longitude]="point.lng">
                      <label for=""></label>
                    </agm-polyline-point>
                  </agm-polyline>


                  <agm-marker [latitude]="pointse[i].element[0].lat" [longitude]="pointse[i].element[0].lng"
                    [iconUrl]="$any(iconsalida)" [agmFitBounds]="true"></agm-marker>


                  <agm-marker [latitude]="colegioLatitud" [longitude]="colegioLongitud" [iconUrl]="$any(iconColegio)"
                    [agmFitBounds]="true"></agm-marker>


                  <agm-marker [latitude]="pointse[i].element[pointse[i].element.length-1].lat"
                    [longitude]="pointse[i].element[pointse[i].element.length-1].lng" [iconUrl]="$any(iconllegada)"
                    [agmFitBounds]="true"></agm-marker>

                </div>
              </agm-map>




              <agm-map [zoom]="12" [latitude]="-0.1824411" [longitude]="-78.4605962" [clickableIcons]="false"
                *ngIf="pointse.length==0">

              </agm-map>

            </div>
          </div>



        </div>


        <div style="text-align: right;width: 100%;padding: 15px;padding-right: 50px;">
          <div class="row">

            <div class="col"><button class="btn btn-primary" mat-button (click)="goForward(stepper)">Continuar</button>&nbsp;&nbsp;
              <button class="btn btn-warning" mat-button (click)="goBack(stepper)">Regresar</button>
              
            </div>
          </div>
        </div>

      </form>
    </mat-step>




    <!--cinco step almacenamiento-->
    <!--*************************************-->
    <!--*************************************-->
    <!--*************************************-->
    <mat-step>
      <ng-template matStepLabel>T&C</ng-template>
      <h2 class="main-div" *ngIf="finalizarSinContrato"><b>Términos y Condiciones</b></h2>

      <div *ngIf="finalizarSinContrato">



        <div class="row" style="padding-bottom: 5px;">
          <div class="col-sm"></div>
          <div class="col-sm" style="text-align: center;">
            <button class="btn btn-secondary" style="width: 280px;padding-top: 6px;" mat-button (click)="goBack(stepper)">Atrás</button>
          </div>
          <div class="col-sm" style="text-align: center;padding-top: 6px;">
            <button class="btn btn-primary" mat-button (click)="descargarPDFNew()">Aceptar Los
              Términos y
              Condiciones</button>
          </div>
          <div class="col-sm"></div>
        </div>







      </div>





      <div class="row" style="padding: 20px;">

        <div *ngIf="pdfLink">
          <pdf-viewer [src]="GetLinkPDF" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="false"
            [zoom]="0.7" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
            [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false" class="viewer"></pdf-viewer>

        </div>




        <div class="pdf-container" style="padding-top: 5px;" *ngIf="GetMuestraFinal == 'CONTRATO' &&pdfMake==true">
          <pdf-viewer [src]="safeSrc" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="false"
            [zoom]="0.7" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
            [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false" class="viewer"></pdf-viewer>
        </div>





      </div>



    </mat-step>
  </mat-horizontal-stepper>
</div>